/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UnmatchedDataPoint } from './UnmatchedDataPoint';
import {
    UnmatchedDataPointFromJSON,
    UnmatchedDataPointFromJSONTyped,
    UnmatchedDataPointToJSON,
    UnmatchedDataPointToJSONTyped,
} from './UnmatchedDataPoint';

/**
 * 
 * @export
 * @interface PaginatedUnmatchedDataPointList
 */
export interface PaginatedUnmatchedDataPointList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnmatchedDataPointList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnmatchedDataPointList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedUnmatchedDataPointList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<UnmatchedDataPoint>}
     * @memberof PaginatedUnmatchedDataPointList
     */
    results: Array<UnmatchedDataPoint>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedUnmatchedDataPointList
     */
    numPages?: number;
}

/**
 * Check if a given object implements the PaginatedUnmatchedDataPointList interface.
 */
export function instanceOfPaginatedUnmatchedDataPointList(value: object): value is PaginatedUnmatchedDataPointList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedUnmatchedDataPointListFromJSON(json: any): PaginatedUnmatchedDataPointList {
    return PaginatedUnmatchedDataPointListFromJSONTyped(json, false);
}

export function PaginatedUnmatchedDataPointListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedUnmatchedDataPointList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(UnmatchedDataPointFromJSON)),
        'numPages': json['num_pages'] == null ? undefined : json['num_pages'],
    };
}

export function PaginatedUnmatchedDataPointListToJSON(json: any): PaginatedUnmatchedDataPointList {
    return PaginatedUnmatchedDataPointListToJSONTyped(json, false);
}

export function PaginatedUnmatchedDataPointListToJSONTyped(value?: PaginatedUnmatchedDataPointList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(UnmatchedDataPointToJSON)),
        'num_pages': value['numPages'],
    };
}

